// import AddMultipleAssigneeDropdown from '../AddMultipleAssigneeDropdown';
import AssigneeNew from "components/AddMultipleMemberDropDownNew/AddMultipleMemberDropDownNew";
import InfoTooltip from "components/Tooltip/InfoTooltip";
import { CommonCardContainer } from "components/DashboardCards/cardStyles";
import { MapAndAlertContainer } from "custom_modules/FieldServices/RouteMap/routeMapStyles";
import { workOrderShortListRequestFailureHandler } from "custom_modules/WorkOrderNew/workOrderReducers";
import moment from "moment-timezone";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody } from "reactstrap";
import { CheckboxDiv, CheckboxTickIcon } from "styledComponents/settings";

import durationIcon from "../../../assets/img/icons/clock-in-duration.svg";
import crossIcon from "../../../assets/img/icons/cross_black.svg";
import deleteIcon from "../../../assets/img/icons/delete-3.svg";
import Plus from "../../../assets/img/icons/plus_primary.svg";
import PlusWhite from "../../../assets/img/icons/plus_white.svg";
import tickWhite from "../../../assets/img/icons/tick_2.svg";
import tick from "../../../assets/img/onboardingImg/tick-black.svg";
import AddOrgLocationModal from "../../../components/AddOrgLocationModal/AddOrgLocationModal";
import AddSingleMemberDropdown from "../../../components/CustomDropdown/AddSingleMemberDropdown";
import CreateProjectDropdown from "../../../components/DropdownStyle/CreateProjectDropdown";
import ButtonTextLoader from "../../../components/Loaders/ButtonTextLoader";
import ComponentCircleLoader from "../../../components/Loaders/ComponentCircleLoader";
import PricingPlan from "../../../components/PricingPlan";
import Select from "../../../components/ReactSelectDropdown";
import { filterOption } from "../../../components/ReactSelectDropdown/ReactSelectDropdown";
import RoundTab from "../../../components/RoundTabButtons/RoundTab";
import { ClearSearchButton } from "../../../components/Search/searchStyles";
import DatePicker from "../../../components/SingleDatePicker/SingleDatePicker";
import SingleDatePicker from "../../../components/SingleDatePicker/SingleDatePicker";
import WeekdaySelector from "../../../components/WeekdaySelector/WeekdaySelector";
import {
  CardsContainer,
  HorizontalLineDivider,
} from "../../../styledComponents/Activity";
import {
  BorderButtonWithIcon,
  ButtonIcon,
  ColoredButtonWithIcon,
  PrimaryButton,
  WhiteButton,
} from "../../../styledComponents/buttons";
import {
  TabButton,
  TabButtonContainer,
} from "../../../styledComponents/buttons";
import {
  ColoredText,
  CommonFlex,
  CommonGrid,
  CommonImage,
  CommonText,
  Container,
  FormAlert,
  InputField,
  InputLabel,
  InputTextArea,
  InputWithLabelSection,
  ModalCrossIcon,
  PageTitle,
  RedStar,
} from "../../../styledComponents/common";
import { CrossIcon } from "../../../styledComponents/createProject";
import {
  ToggleButton,
  ToggleButtonRound,
} from "../../../styledComponents/invoice";
import { RadioButton } from "../../../styledComponents/members";
import { formatDurationToHoursMinutes } from "../../../utils/helper";
import { checkHtml, checkUrl } from "../../../utils/helper";
import { timezoneToCoords } from "../../../utils/timeZoneCoordinates";
import { useWeekConfig } from "../../../utils/weekConfig";
import AddLocationModal from "../../ClientsNew/ClientDetails/AddLocationModal";
import ClientModal from "../../WorkOrderNew/CreateWorkOrder/ClientModal";
import AddSubTaskModal from "../../Jobs/CreateJob/AddSubTaskModal";
import EditSubTaskModal from "../../Jobs/CreateJob/EditSubTaskModal";
import SingleLocationMap from "../../Jobs/CreateJob/SingleLocationMap";
import JobInputSection from "../../JobComponents/JobInputSection";
import JobStartTimeSection from "../../JobComponents/JobStartTimeSection";
import RecurringScheduleSection from "../../JobComponents/RecurringScheduleSection";
import LineItemSection from "../../JobComponents/LineItemSection";
import SubtaskSection from "../../JobComponents/SubtaskSection";
import DocumentUploadSection from "../../JobComponents/DocumentUploadSection";
import CreateProjectModal from "../../Jobs/CreateJob/createProjectModalContainer";
import {
  AdditionalOptionText,
  DurationContainer,
  DurationText,
  MonthDateBox,
  MonthDateContainer,
  RepeatSection,
  ScheduleText,
  ThemeBox,
  ThemesContainer,
  WeekDaysContainer,
  WeekNumberBox,
  WeekdayBox,
} from "../../ShiftSchedule/CreateShift/createShiftStyles";
import TimeRangeComponent from "../../Timesheet/Daily/TimeRangeComponent";
import JobConflictSidePanelContainer from "custom_modules/Jobs/JobConflictSidePanel/JobConflictSidePanelContainer";

const SHORT_WEEK_DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const FULL_WEEK_DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const CreateJobPopupNew = ({
  selectedOrganization,
  orgMembersShortList,
  jobAssigneeMemberList,
  memberShortListIsLoading,
  jobAssigneeMemberListIsLoading,
  getOrganizationMembersShortList,
  getJobAssigneeMemberList,
  getTaskType,
  taskTypeList,
  //workorder short
  getWorkOrderShortList,
  workOrderShortList,

  //customer location
  clientLocationList,
  getclientLocalMapLoading,
  addOrUpdateclientLocalMapLoading,
  createdClientLocationInfo,

  getClientLocation,
  addClientLocation,
  updateClientLocation,

  //organization location
  organizationLocationList,
  getOrganizationLocationLoading,
  addOrgLocationLoading,
  createdOrgLocationInfo,
  getOrganizationLocations,
  createOrgLocation,

  //job
  createJobRequest,
  createdJob,
  createOrUpdateJobIsLoading,
  isJobLimitFull,

  //client
  createClient,
  isClientLoading,
  createdClientId,
  createdClientInfo,
  clientShortList,
  getClientShortList,

  //modal props
  isOpen,
  toggle,
  onCreateChange,
  workOrder,
  pricingPopupToggle,
}) => {
  const MONTH_GRID_COLUMNS = 7;
  const MONTH_TOTAL_DAYS = 31;
  const LAST_DAY_SPAN_COLUMNS =
    (MONTH_GRID_COLUMNS - (MONTH_TOTAL_DAYS % MONTH_GRID_COLUMNS)) %
      MONTH_GRID_COLUMNS || MONTH_GRID_COLUMNS;
  const { t, i18n } = useTranslation();

  // Dynamic labels and paths based on organization type (default to "operation" if not defined)
  const orgType = selectedOrganization?.type || "operation";
  const isOperationType = orgType === "operation";
  const createItemLabel = isOperationType ? t("create_task") : t("create_job");
  const addItemDetailsLabel = isOperationType
    ? t("add_task_details")
    : t("add_job_details");
  const itemNameLabel = isOperationType ? t("task_name") : t("job_name");
  const typeItemNameLabel = isOperationType
    ? t("type_task_name")
    : t("type_job_name");
  const itemStartDateLabel = isOperationType
    ? t("task_start_date")
    : t("job_start_date");
  const itemDurationLabel = isOperationType
    ? t("task_duration")
    : t("job_duration");
  const workOrderLabel = isOperationType ? t("project") : t("job");
  const selectWorkOrderLabel = isOperationType
    ? t("select_project")
    : t("select_job");
  const itemNameRequiredError = isOperationType
    ? "Task name is required"
    : "Job name is required";
  const itemNameUrlError = isOperationType
    ? "Task name can not contain url."
    : "Job name can not contain url.";
  const itemNameInvalidError = isOperationType
    ? "Invalid Task name"
    : "Invalid Job name";
  const itemDescriptionUrlError = isOperationType
    ? "Task description can not contain url."
    : "Job description can not contain url.";
  const itemDescriptionInvalidError = isOperationType
    ? "Invalid Task description"
    : "Invalid Job description";
  const workOrderRequiredError = isOperationType
    ? "Project is required"
    : "Job is required";
  const pricingPopupTextLabel = isOperationType
    ? "You have reached the limit of creating tasks."
    : "You have reached the limit of creating jobs.";
  const pricingPopupTitleLabel = isOperationType
    ? "Upgrade to Elite to create unlimited tasks"
    : "Upgrade to Elite to create unlimited jobs";
  const recurringJobsTextLabel = isOperationType
    ? "You can't create recurring tasks in your current plan"
    : "You can't create recurring jobs in your current plan";
  const recurringJobsTitleLabel = isOperationType
    ? "Upgrade to Elite to create recurring tasks"
    : "Upgrade to Elite to create recurring jobs";
  const [jobName, setJobName] = useState("");
  const [selectedWorkOrder, setSelectedWorkOrder] = useState("");
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [taskDescription, setTaskDescription] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [jobLocationOptions, setJobLocationOptions] = useState([]);
  // const [radiusInput, setRadiusInput] = useState(100);
  // const [isCustomRadius, setIsCustomRadius] = useState(false);
  // Initialize with default times (matching TimeRangeComponent defaults)
  const initialStartTime = (() => {
    const roundedMins = Math.ceil(moment().minutes() / 5) * 5;
    return moment()
      .minutes(roundedMins + 10)
      .format("HH:mm:ss");
  })();
  const initialEndTime = (() => {
    const roundedMins = Math.ceil(moment().minutes() / 5) * 5;
    return moment()
      .minutes(roundedMins + 70)
      .format("HH:mm:ss");
  })();

  const [startDate, setStartDate] = useState(moment(new Date()));
  const [startTime, setStartTime] = useState(initialStartTime);
  const [endTime, setEndTime] = useState(initialEndTime);
  const [selectedRepeatType, setSelectedRepeatType] = useState("");
  const [defaultRepeatOptions, setDefaultRepeatOptions] = useState([]);
  const [selectedScheduleForType, setSelectedScheduleForType] = useState("now");
  const [interval, setInterval] = useState(1);
  const [activeDays, setActiveDays] = useState({
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
  });
  const [isWeekViewOfMonth, setIsWeekViewOfMonth] = useState(false);
  const [activeMonthDates, setActiveMonthDates] = useState({});
  const [activeMonthDays, setActiveMonthDays] = useState({});
  const [scheduleDescription, setScheduleDescription] = useState("");
  const [endDate, setEndDate] = useState(null);
  const [selectedTaskType, setSelectedTaskType] = useState("");
  const [popupOpen, setPopupOpen] = useState(false);
  const [pricingPopup, setPricingPopup] = useState(false);
  const [pricingPopupText, setPricingPopupText] = useState(
    pricingPopupTextLabel,
  );
  const [pricingPopupTitle, setPricingPopupTitle] = useState(
    pricingPopupTitleLabel,
  );
  const [isStandardPlan, setIsStandardPlan] = useState(false);
  const [saveErrors, setSaveErrors] = useState({});
  const radiusOptions = [20, 50, 100];
  const [statusOptions, setStatusOptions] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [workOrderOptions, setWorkOrderOptions] = useState([]);
  const [clientId, setClientId] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);
  const [addLocationButton, setAddLocationButton] = useState(false);
  const [action, setAction] = useState("add");
  const [themeColor, setThemeColor] = useState("");
  const [customerName, setCustomerName] = useState("");
  // map states
  const [map, setMap] = useState(null);
  const [addressMarker, setAddressMarker] = useState(null);
  const [isAnyTimeSet, setIsAnyTimeSet] = useState(false);
  const [isSubTaskModalOpen, setIsSubTaskModalOpen] = useState(false);
  const [isEditSubTaskModalOpen, setIsEditSubTaskModalOpen] = useState(false);
  const [subTaskList, setSubTaskList] = useState([]);
  const [selectedSubTaskId, setSelectedSubTaskId] = useState(null);
  const [lineItems, setLineItems] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [isClientModalOpen, setIsClientModalOpen] = useState(false);
  const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
  const [filteredWorkOrderOptions, setFilteredWorkOrderOptions] = useState([]);
  const [isConflictPanelOpen, setIsConflictPanelOpen] = useState(false);
  const [conflictAssignee, setConflictAssignee] = useState(null);
  
  const openEditSubTaskModal = subTaskId => {
    setSelectedSubTaskId(subTaskId);
    setIsEditSubTaskModalOpen(true);
  };

  const closeEditSubTaskModal = () => {
    setIsEditSubTaskModalOpen(false);
    setSelectedSubTaskId(null);
  };
  const [isRecurringScheduleOpen, setIsRecurringScheduleOpen] = useState(false);
  const jobInputRef = useRef(null);
  const scrollName = useRef(null);
  const scrollDescription = useRef(null);
  const scrollTime = useRef(null);
  const weekDays = SHORT_WEEK_DAYS;
  const [selectedRecurringSchedule, setSelectedRecurringSchedule] =
    useState("daily");
  const [selectedRecurringScheduleDays, setSelectedRecurringScheduleDays] =
    useState([]);
  const [monthlyScheduleMode, setMonthlyScheduleMode] = useState("dates"); // "dates" | "days"
  const dateText = {
    1: "1st",
    2: "2nd",
    3: "3rd",
    21: "21st",
    22: "22nd",
    23: "23rd",
    31: "31st",
    "Last Day": "last",
  };
  const [jobNumber, setJobNumber] = useState("");
  const onJobNumberChange = e => {
    setJobNumber(e.target.value);
  };
  const capitalizeSummary = text =>
    text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
  const DEFAULT_LOCATION_RADIUS = 100;
  const buildLocationOption = location => {
    if (!location) {
      return null;
    }
    return {
      value: location.id,
      label: location.name,
      latitude: location.latitude,
      longitude: location.longitude,
      radius:
        location.radius !== undefined && location.radius !== null
          ? location.radius
          : DEFAULT_LOCATION_RADIUS,
      address: location.address,
      is_default:
        location.is_default !== undefined && location.is_default !== null
          ? location.is_default
          : location.default || false,
      client: location.client,
    };
  };

  const toggleClientModal = () => {
    setIsClientModalOpen(prev => !prev);
  };

  const clientOptions = useMemo(() => {
    if (!clientShortList || clientShortList.length === 0) return [];
    return clientShortList
      .map(client => ({
        value: client.id,
        label: client.name,
      }))
      .filter(opt => opt.value && opt.label);
  }, [clientShortList]);

  const generateJobNumber = prefix => {
    const cleanedPrefix =
      prefix && typeof prefix === "string"
        ? prefix.substring(0, 3).toUpperCase().replace(/\s/g, "")
        : "";
    const randomNum = Math.floor(Math.random() * 9000) + 1000;
    return cleanedPrefix ? `${cleanedPrefix}${randomNum}` : `JOB${randomNum}`;
  };

  const handleClientChange = option => {
    let errors = { ...saveErrors };
    delete errors["selectedClient"];
    setSaveErrors(errors);

    setSelectedClient(option || null);
    const newClientId = option?.value || "";
    setClientId(newClientId);
    setCustomerName(option?.label || "");

    // Switching customer should reset dependent selections for service
    if (orgType === "service") {
      setSelectedLocation(null);
      setJobLocationOptions([]);
      
      // Filter work orders by client_id and auto-select first matching work order
      if (newClientId && workOrderOptions.length > 0) {
        const filtered = workOrderOptions.filter(
          wo => String(wo.client_id) === String(newClientId)
        );
        setFilteredWorkOrderOptions(filtered);
        
        // Auto-select first matching work order, or clear if none found
        if (filtered.length > 0) {
          setSelectedWorkOrder(filtered[0]);
        } else {
          setSelectedWorkOrder(null);
        }
      } else {
        // No client selected, show all work orders
        setFilteredWorkOrderOptions(workOrderOptions);
        setSelectedWorkOrder(null);
      }
    }

    // Auto-generate job number for service org type when customer is selected
    if (orgType === "service" && (!jobNumber || jobNumber.trim() === "")) {
      const customerName = option?.label || option?.name || "";
      setJobNumber(generateJobNumber(customerName));
    }
  };

  const updateSelectedLocationState = option => {
    // Gate location selection by org type prerequisites
    if (orgType === "service") {
      // For service, locations are tied to customer
      if (!clientId) return;
    } else if (orgType !== "operation") {
      // For other non-operation org types, require work order
      if (!selectedWorkOrder) return;
    }
    if (option) {
      setSelectedLocation(option);
      setCustomerName(prevName => option.client?.name || prevName || "");
    } else {
      setSelectedLocation(null);
      // Don't clear customer name - it comes from work order, not location
    }
  };
  const selectedLocationId = selectedLocation?.value || null;
  const daysOfWeek = FULL_WEEK_DAYS;

  const hasInitializedRef = useRef(false);

  // Shared initial fetches
  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id && isOpen && !hasInitializedRef.current) {
      getWorkOrderShortList({ organization_id: selectedOrganization.id });
      getOrganizationMembersShortList({
        organization_id: selectedOrganization.id,
      });
      
      // Initialize workOrder from props if provided (workOrder is fixed, won't change)
      if (workOrder && workOrder.value) {
        setSelectedWorkOrder(workOrder);
        setClientId(workOrder.client_id);
        setCustomerName(workOrder.client_name || "");
        // Generate job number when work order is set
        if (workOrder.label || workOrder.name) {
          let prefix = "";
          if (orgType === "operation") {
            const workOrderName = workOrder.label || workOrder.name;
            prefix = workOrderName
              .substring(0, 3)
              .toUpperCase()
              .replace(/\s/g, "");
          } else {
            if (workOrder.client_name) {
              prefix = workOrder.client_name.substring(0, 3).toUpperCase();
            } else {
              const workOrderName = workOrder.label || workOrder.name;
              prefix = workOrderName
                .substring(0, 3)
                .toUpperCase()
                .replace(/\s/g, "");
            }
          }
          if (prefix) {
            const randomNum = Math.floor(Math.random() * 9000) + 1000;
            setJobNumber(`${prefix}${randomNum}`);
          }
        }
      }

      // Initialize start date with rounded minutes
      const roundedMinsStartDate = Math.ceil(moment().minutes() / 5) * 5;
      const newStartDate = moment().minutes(roundedMinsStartDate + 10);
      setStartDate(newStartDate);
      hasInitializedRef.current = true;
    }
  }, [
    selectedOrganization?.id,
    isOpen,
    getWorkOrderShortList,
    getOrganizationMembersShortList,
  ]);

  useEffect(() => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      startDate &&
      startTime &&
      endTime
    ) {
      const start_time = `${startDate.format("YYYY-MM-DD")}T${startTime}`;
      const endDateForQuery =
        isRecurringScheduleOpen && endDate ? endDate : startDate;
      const end_time = `${endDateForQuery.format("YYYY-MM-DD")}T${endTime}`;

      getJobAssigneeMemberList({
        organization_id: selectedOrganization.id,
        start_time,
        end_time,
      });
    }
  }, [
    selectedOrganization,
    startDate,
    startTime,
    endTime,
    endDate,
    isRecurringScheduleOpen,
    getJobAssigneeMemberList,
  ]);

  // Operation-specific initial fetches
  useEffect(() => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      orgType === "operation" &&
      isOpen
    ) {
      getOrganizationLocations({ organization_id: selectedOrganization.id });
    }
  }, [selectedOrganization, orgType, isOpen]);

  // Service-specific initial fetches
  useEffect(() => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      orgType === "service" &&
      isOpen
    ) {
      getClientShortList({ organization_id: selectedOrganization.id });
      // Reset service-specific selections when org/type changes
      setSelectedClient(null);
      setClientId("");
      setCustomerName("");
      setSelectedLocation(null);
      setJobLocationOptions([]);
    }
  }, [selectedOrganization, orgType, isOpen]);

  // Reset initialization flag when modal closes
  useEffect(() => {
    if (!isOpen) {
      hasInitializedRef.current = false;
    }
  }, [isOpen]);

  // Handle created client location for service type
  useEffect(() => {
    if (
      orgType !== "operation" &&
      createdClientLocationInfo &&
      createdClientLocationInfo.id
    ) {
      updateSelectedLocationState(
        buildLocationOption(createdClientLocationInfo),
      );
    }
  }, [createdClientLocationInfo, orgType]);

  // Handle created organization location for operation type
  useEffect(() => {
    if (
      orgType === "operation" &&
      createdOrgLocationInfo &&
      createdOrgLocationInfo.id
    ) {
      // Refresh organization locations list first to get updated list
      if (selectedOrganization && selectedOrganization.id) {
        getOrganizationLocations({
          organization_id: selectedOrganization.id,
        });
      }
      // Update selected location after a short delay to allow list to refresh
      setTimeout(() => {
        updateSelectedLocationState(
          buildLocationOption(createdOrgLocationInfo),
        );
      }, 300);
    }
  }, [createdOrgLocationInfo, orgType, selectedOrganization]);

  // Fetch client locations for service type only
  useEffect(() => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      clientId &&
      orgType !== "operation"
    ) {
      getClientLocation({
        organization_id: selectedOrganization.id,
        client_id: clientId,
      });
    }
  }, [clientId, orgType]);

  useEffect(() => {
    if (workOrderShortList && workOrderShortList.length > 0) {
      let newArr = [];
      workOrderShortList.forEach((workorder, i) => {
        newArr.push({
          label: workorder.name,
          value: workorder.id,
          client_id: workorder.client_id,
          client_name: workorder.client_name,
        });
      });
      setWorkOrderOptions(newArr);
      
      // Filter work orders by client_id for service org type
      if (orgType === "service" && clientId) {
        const filtered = newArr.filter(
          wo => String(wo.client_id) === String(clientId)
        );
        setFilteredWorkOrderOptions(filtered);
      } else {
        // For operation type or when no client selected, show all work orders
        setFilteredWorkOrderOptions(newArr);
      }
    } else {
      setWorkOrderOptions([]);
      setFilteredWorkOrderOptions([]);
    }
  }, [workOrderShortList, orgType, clientId]);

  // Service requires a workOrder_id for the create API, but we keep it hidden.
  // Auto-select one work order (first item) once the list is loaded.
  // For service type, only auto-select from work orders matching the selected customer.
  useEffect(() => {
    if (orgType !== "service" || !isOpen) return;
    
    // Use filtered work orders if client is selected, otherwise use all work orders
    const workOrdersToUse = clientId && filteredWorkOrderOptions.length > 0
      ? filteredWorkOrderOptions
      : workOrderOptions;
    
    if (!workOrdersToUse || workOrdersToUse.length === 0) return;

    const hasSelected =
      selectedWorkOrder &&
      typeof selectedWorkOrder === "object" &&
      !!selectedWorkOrder.value;
    
    if (!hasSelected) {
      // For service type with client selected, only select from filtered list
      if (clientId && filteredWorkOrderOptions.length > 0) {
        setSelectedWorkOrder(filteredWorkOrderOptions[0]);
      } else if (!clientId) {
        // No client selected yet, select first from all work orders
        setSelectedWorkOrder(workOrderOptions[0]);
      }
    }
  }, [orgType, workOrderOptions, filteredWorkOrderOptions, selectedWorkOrder, clientId, isOpen]);

  // Ensure newly created customer shows up in the dropdown
  useEffect(() => {
    if (
      orgType === "service" &&
      selectedOrganization &&
      selectedOrganization.id &&
      createdClientId &&
      isOpen
    ) {
      getClientShortList({ organization_id: selectedOrganization.id });
      // Refetch work orders to include any new work orders for the new client
      getWorkOrderShortList({ organization_id: selectedOrganization.id });
    }
  }, [createdClientId, orgType, selectedOrganization, isOpen]);
  
  // Filter and auto-select work order when new client is created and work orders are loaded
  useEffect(() => {
    if (
      orgType === "service" &&
      createdClientId &&
      workOrderOptions.length > 0 &&
      isOpen
    ) {
      // Filter work orders by the newly created client_id
      const filtered = workOrderOptions.filter(
        wo => String(wo.client_id) === String(createdClientId)
      );
      setFilteredWorkOrderOptions(filtered);
      
      // Auto-select first matching work order if available
      if (filtered.length > 0) {
        setSelectedWorkOrder(filtered[0]);
      }
    }
  }, [createdClientId, workOrderOptions, orgType, isOpen]);

  // useEffect(() => {
  //   if (locationsList && locationsList.length > 0) {
  //     let newArr = [];
  //     locationsList.forEach(location => {
  //       newArr.push({
  //         label: location.name,
  //         value: location.id,
  //         ...location,
  //       });
  //     });
  //     setJobLocationOptions(newArr);
  //   }
  // }, [locationsList]);

  // Handle client locations for service type
  useEffect(() => {
    if (orgType !== "operation" && clientLocationList) {
      if (clientLocationList.length > 0) {
        const formattedOptions = clientLocationList
          .map(location => buildLocationOption(location))
          .filter(option => option && option.latitude && option.longitude);
        setJobLocationOptions(formattedOptions);
        if (
          !selectedLocation ||
          !formattedOptions.some(
            option => option.value === selectedLocation.value,
          )
        ) {
          const defaultOption =
            formattedOptions.find(option => option.is_default === true) ||
            formattedOptions[0];
          updateSelectedLocationState(defaultOption || null);
        }
      } else if (clientLocationList.length === 0) {
        setJobLocationOptions([]);
        setSelectedLocation(null);
      }
    }
  }, [clientLocationList, selectedLocationId, orgType]);

  // Handle organization locations for operation type
  useEffect(() => {
    if (orgType === "operation" && organizationLocationList) {
      if (organizationLocationList.length > 0) {
        const formattedOptions = organizationLocationList
          .map(location => buildLocationOption(location))
          .filter(option => option && option.latitude && option.longitude);
        setJobLocationOptions(formattedOptions);
        if (
          !selectedLocation ||
          !formattedOptions.some(
            option => option.value === selectedLocation.value,
          )
        ) {
          const defaultOption =
            formattedOptions.find(option => option.is_default === true) ||
            formattedOptions[0];
          updateSelectedLocationState(defaultOption || null);
        }
      } else if (organizationLocationList.length === 0) {
        setJobLocationOptions([]);
        setSelectedLocation(null);
      }
    }
  }, [organizationLocationList, selectedLocationId, orgType]);

  useEffect(() => {
    if (taskTypeList && taskTypeList.length > 0) {
      let newArr = [];
      if (i18n.language && i18n.language === "en") {
        taskTypeList.forEach(type => {
          newArr.push({
            label: type.name,
            value: type.id,
          });
        });
      } else {
        taskTypeList.forEach(type => {
          newArr.push({
            label: type.arabic_name,
            value: type.id,
          });
        });
      }
      setStatusOptions(newArr);
    }
  }, [taskTypeList]);

  useEffect(() => {
    if (createdJob && isSubmitted) {
      onCreateChange();
      toggle();
      clearState();
    }
  }, [createdJob, isSubmitted]);

  useEffect(() => {
    if (isJobLimitFull && isSubmitted) {
      setPricingPopup(true);
    }
  }, [isJobLimitFull]);

  // Close recurring schedule when "Later" is selected
  useEffect(() => {
    if (selectedScheduleForType === "later" && isRecurringScheduleOpen) {
      setIsRecurringScheduleOpen(false);
    }
  }, [selectedScheduleForType]);

  // Set end date to start date when recurring schedule is opened
  useEffect(() => {
    if (isRecurringScheduleOpen && !endDate && startDate) {
      setEndDate(startDate);
    }
  }, [isRecurringScheduleOpen, startDate]);

  // Ensure end date is not before start date
  useEffect(() => {
    if (endDate && startDate) {
      if (moment(endDate).isBefore(moment(startDate), "day")) {
        setEndDate(startDate);
        // Clear endDate error if it exists
        let errors = { ...saveErrors };
        delete errors["endDate"];
        setSaveErrors(errors);
      }
    }
  }, [startDate, endDate]);

  const locationInputOpen = () => {
    setAddLocationButton(true);
  };

  const onTaskNameChange = e => {
    let errors = { ...saveErrors };
    delete errors["jobName"];
    setSaveErrors(errors);
    setJobName(e.target.value);
  };

  const onWorkOrderChange = e => {
    setSelectedWorkOrder(e);

    // For operation type, customer/client is not required
    if (orgType === "operation") {
      setClientId("");
      setCustomerName("");
      // Don't clear location options - they're independent of work order
    } else {
      // For service type, work order is an internal requirement and must not override customer.
    }

    // Auto-generate job number only for operation org type
    if (orgType === "operation" && (!jobNumber || jobNumber.trim() === "")) {
      const workOrderName = e.label || e.name || "";
      setJobNumber(generateJobNumber(workOrderName));
    }
    // If jobNumber already has a value (user set it), keep it as is - don't modify
  };

  const handleAssignOrRemoveMember = (user, action) => {
    if (user && user.id) {
      let newArr = [...selectedAssignees];
      if (action === "remove") {
        newArr = newArr.filter(member => member.id !== user.id);
      } else {
        newArr.push(user);
      }
      setSelectedAssignees(newArr);
    }
  };

  const handleAssignMember = user => {
    handleAssignOrRemoveMember(user, "assign");
  };

  const handleRemoveMember = user => {
    handleAssignOrRemoveMember(user, "remove");
  };

  const onTaskDescriptionChange = e => {
    let errors = { ...saveErrors };
    delete errors["taskDescription"];
    setSaveErrors(errors);
    setTaskDescription(e.target.value);
  };

  const onLocationChange = option => {
    updateSelectedLocationState(option);
  };

  const onDateChange = date => {
    setStartDate(date);
  };

  const onMonthDateSelect = date => {
    let errors = { ...saveErrors };
    delete errors["activeMonthDates"];
    setSaveErrors(errors);
    let tempActiveMonthDates = { ...activeMonthDates };
    tempActiveMonthDates[date] = !tempActiveMonthDates[date];
    setActiveMonthDates(tempActiveMonthDates);
  };

  const onMonthDaySelect = day => {
    let errors = { ...saveErrors };
    delete errors["activeMonthDays"];
    setSaveErrors(errors);
    let tempActiveMonthDays = { ...activeMonthDays };
    tempActiveMonthDays[day] = !tempActiveMonthDays[day];
    setActiveMonthDays(tempActiveMonthDays);
  };

  const onRecurringScheduleTypeChange = scheduleType => {
    setSelectedRecurringSchedule(scheduleType);
    let errors = { ...saveErrors };
    delete errors["selectedRecurringSchedule"];
    setSaveErrors(errors);
    // For monthly, ensure interval is one of the valid options (1, 2, 3, 6, 12), default to 1
    if (scheduleType === "monthly") {
      const validMonthlyIntervals = [1, 2, 3, 6, 12];
      if (!validMonthlyIntervals.includes(interval)) {
        setInterval(1);
      }
    }
  };

  const findDateText = date => {
    if (dateText[date]) {
      return dateText[date];
    } else {
      return `${date}th`;
    }
  };

  const monthlyDatesSummary = useMemo(() => {
    const selectedDates = [];
    for (let i = 1; i <= MONTH_TOTAL_DAYS; i++) {
      if (activeMonthDates[i]) {
        selectedDates.push(findDateText(i));
      }
    }
    if (activeMonthDates["Last Day"]) {
      selectedDates.push("last day");
    }
    if (!selectedDates.length) {
      return "";
    }
    if (selectedDates.length === 1) {
      return `${capitalizeSummary(selectedDates[0])} of each month`;
    }
    const lastEntry = selectedDates.pop();
    return `${selectedDates.join(", ")} and ${lastEntry} of each month`;
  }, [activeMonthDates]);

  const monthlyDaysSummary = useMemo(() => {
    const selections = [];
    for (let weekIndex = 0; weekIndex < 4; weekIndex++) {
      for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
        const key = weekIndex * 7 + dayIndex;
        if (activeMonthDays[key]) {
          const weekLabel = findDateText(weekIndex + 1);
          const dayLabel = FULL_WEEK_DAYS[dayIndex];
          selections.push(`${weekLabel} ${dayLabel}`);
        }
      }
    }
    if (!selections.length) {
      return "";
    }
    if (selections.length === 1) {
      return `${selections[0]} of each month`;
    }
    const lastEntry = selections.pop();
    return `${selections.join(", ")} and ${lastEntry} of each month`;
  }, [activeMonthDays]);

  const onEndDateSelect = date => {
    let errors = { ...saveErrors };
    delete errors["endDate"];
    setSaveErrors(errors);
    setEndDate(date);
  };

  const onActiveDaysSelect = day => {
    let errors = { ...saveErrors };
    delete errors["activeDays"];
    setSaveErrors(errors);
    let tempActiveDays = { ...activeDays };
    tempActiveDays[day] = !tempActiveDays[day];
    setActiveDays(tempActiveDays);
  };

  const clearState = () => {
    setJobName("");
    setSelectedWorkOrder(workOrder && workOrder.value ? workOrder : "");
    setSelectedAssignees([]);
    const roundedMinsStartDate = Math.ceil(moment().minutes() / 5) * 5;
    const newStartDate = moment().minutes(roundedMinsStartDate + 10);
    setStartDate(newStartDate);
    setStartTime(initialStartTime);
    setEndTime(initialEndTime);
    setSelectedRepeatType("");
    setDefaultRepeatOptions([]);
    setInterval(1);
    setActiveDays({
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
    });
    setIsWeekViewOfMonth(false);
    setActiveMonthDates({});
    setActiveMonthDays({});
    setScheduleDescription("");
    setEndDate(null);
    setTaskDescription("");
    setThemeColor("");
    setSelectedLocation(null);
    setCustomerName(
      workOrder && workOrder.client_name ? workOrder.client_name : "",
    );
    setSubTaskList([]);
    setLineItems([]);
    setDocuments([]);
    setIsRecurringScheduleOpen(false);
    setSelectedScheduleForType("now");
    setIsAnyTimeSet(false);
    setJobNumber("");
    setSelectedClient(null);
    setFilteredWorkOrderOptions([]);
    // Regenerate job number if workOrder is set
    if (workOrder && workOrder.value) {
      let prefix = "";
      if (orgType === "operation") {
        if (workOrder.label || workOrder.name) {
          const workOrderName = workOrder.label || workOrder.name;
          prefix = workOrderName
            .substring(0, 3)
            .toUpperCase()
            .replace(/\s/g, "");
        }
      } else {
        if (workOrder.client_name) {
          prefix = workOrder.client_name.substring(0, 3).toUpperCase();
        } else if (workOrder.label || workOrder.name) {
          const workOrderName = workOrder.label || workOrder.name;
          prefix = workOrderName
            .substring(0, 3)
            .toUpperCase()
            .replace(/\s/g, "");
        }
      }
      if (prefix) {
        const randomNum = Math.floor(Math.random() * 9000) + 1000;
        setJobNumber(`${prefix}${randomNum}`);
      }
    }
    setSaveErrors({});
    setIsSubmitted(false);
    setIsConflictPanelOpen(false);
    setConflictAssignee(null);
  };

  const handleCancel = () => {
    // Explicitly clear conflict state FIRST (Solution C - safety net)
    setIsConflictPanelOpen(false);
    setConflictAssignee(null);
    // Then clear everything else
    clearState();
    toggle();
  };

  // Clear state when modal closes
  useEffect(() => {
    if (isOpen) {
      // Force clear conflict panel state when modal opens (Solution A)
      setIsConflictPanelOpen(false);
      setConflictAssignee(null);
    } else {
      clearState();
    }
  }, [isOpen]);

  const parseTimeInput = value => {
    if (!value) {
      return null;
    }
    const cleaned = value.trim();
    const formats = ["HH:mm:ss", "HH:mm", "h:mmA", "h:mm A"];
    const parsed = moment(cleaned, formats, true);
    return parsed.isValid() ? parsed : null;
  };

  const handleStartTime = time => {
    if (time) {
      let errors = { ...saveErrors };
      delete errors["timeDifference"];
      setSaveErrors(errors);
      const parsedTime = parseTimeInput(time);
      setStartTime(parsedTime ? parsedTime.format("HH:mm:ss") : "");
    } else {
      setStartTime("");
    }
  };

  const handleEndTime = time => {
    if (time) {
      let errors = { ...saveErrors };
      delete errors["timeDifference"];
      setSaveErrors(errors);
      const parsedTime = parseTimeInput(time);
      setEndTime(parsedTime ? parsedTime.format("HH:mm:ss") : "");
    } else {
      setEndTime("");
    }
  };

  const onTaskTypeChange = e => {
    setSelectedTaskType(e);
  };

  const popupToggle = () => {
    setPopupOpen(!popupOpen);
  };

  const pricingPopupToggleLocal = () => {
    setPricingPopup(!pricingPopup);
  };

  const handleThemeColor = color => {
    setThemeColor(color);
  };

  const handleDisable = () => {
    let isValid = false;
      if (
        jobName.trim() &&
        selectedWorkOrder &&
        selectedWorkOrder.value &&
        selectedScheduleForType
        // selectedLocation &&
        // selectedLocation.value &&
      ) {
        if (orgType === "service" && !clientId) {
          isValid = false;
          return !isValid;
        }
        if (selectedScheduleForType === "later") {
          // For "later", assignees are optional
          isValid = true;
        } else if (selectedScheduleForType === "now") {
        // For "now", assignees are required
        if (selectedAssignees.length > 0) {
          if (!isRecurringScheduleOpen) {
            isValid = true;
          } else if (isRecurringScheduleOpen && endDate) {
            // Check recurring schedule validations
            if (selectedRecurringSchedule === "weekly") {
              // For weekly, at least one day must be selected
              isValid = selectedRecurringScheduleDays.length > 0;
            } else if (selectedRecurringSchedule === "monthly") {
              // For monthly, check if dates or days mode has selections
              if (monthlyScheduleMode === "dates") {
                const hasSelectedDates = Object.values(activeMonthDates).some(
                  val => val === true,
                );
                isValid = hasSelectedDates;
              } else if (monthlyScheduleMode === "days") {
                const hasSelectedDays = Object.values(activeMonthDays).some(
                  val => val === true,
                );
                isValid = hasSelectedDays;
              }
            } else if (selectedRecurringSchedule === "daily") {
              // Daily doesn't need additional selection
              isValid = true;
            }
          }
        }
      }
    }
    return !isValid;
  };

  const handleSave = () => {
    if (checkError() && checkPlan() && !createOrUpdateJobIsLoading) {
      if (
        selectedOrganization &&
        selectedOrganization.id &&
        selectedWorkOrder &&
        selectedWorkOrder.value
      ) {
        let assigneeIds = [];
        if (selectedAssignees && selectedAssignees.length > 0) {
          selectedAssignees.forEach(element => {
            assigneeIds.push(element.id);
          });
        }
        let payload = {
          organization_id: selectedOrganization.id,
          name: jobName,
          workOrder_id: selectedWorkOrder.value,
          status:
            selectedScheduleForType === "now" ? "scheduled" : "unscheduled",
          org_type: selectedOrganization.type,
          job_no: jobNumber,
        };

        if (assigneeIds && assigneeIds.length > 0) {
          payload.assignees = assigneeIds;
        }

        if (taskDescription && taskDescription !== "") {
          payload.description = taskDescription;
        }

        if (themeColor) {
          payload.theme_color = themeColor;
        }

        if (selectedLocation && selectedLocation.value) {
          payload.location_id = selectedLocation.value;
        }

        // Add is_anytime boolean (matching API response format)
        payload.is_anytime = isAnyTimeSet;

        // Keep service customer explicit (even though API is under workOrder).
        // This should not interfere with operation payload.
        if (orgType === "service" && clientId) {
          payload.client_id = clientId;
        }

        // Operation supports subtasks
        if (orgType === "operation" && subTaskList && subTaskList.length > 0) {
          payload.subtasks = subTaskList.map(subTask => ({
            name: subTask.name,
            description: subTask.description,
            allow_evidences:
              subTask.isAllowedEvidences ?? subTask.allow_evidences ?? false,
          }));
        }
        // Service supports line items (documents uploaded separately)
        if (orgType === "service") {
          payload.subtasks = lineItems;
        }

        if (selectedScheduleForType === "now") {
          // Get organization timezone or default to UTC
          const orgTimezone =
            selectedOrganization?.timezone || moment.tz.guess();

          // Format dates in organization timezone
          const startDateInTz = moment.tz(startDate, orgTimezone);
          payload.required_start_date = startDateInTz
            .format("YYYY-MM-DDTHH:mm:ss");

          // end_time should always be on the same day as start_time
          const endTimeDate = startDateInTz;

          if (isAnyTimeSet) {
            // If anytime is true, set start_time to 00:00 and end_time to 23:59 in org timezone
            payload.start_time = moment
              .tz(
                startDateInTz.format("YYYY-MM-DD") + " 00:00",
                "YYYY-MM-DD HH:mm",
                orgTimezone,
              )
              .format("YYYY-MM-DDTHH:mm:ss");
            payload.end_time = moment
              .tz(
                endTimeDate.format("YYYY-MM-DD") + " 23:59",
                "YYYY-MM-DD HH:mm",
                orgTimezone,
              )
              .format("YYYY-MM-DDTHH:mm:ss");
          } else {
            // If anytime is false, use user-provided start_time and end_time
            if (startTime && endTime) {
              // Parse times in organization timezone
              payload.start_time = moment
                .tz(
                  startDateInTz.format("YYYY-MM-DD") + " " + startTime,
                  "YYYY-MM-DD h:mmA",
                  orgTimezone,
                )
                .format("YYYY-MM-DDTHH:mm:ss");
              payload.end_time = moment
                .tz(
                  endTimeDate.format("YYYY-MM-DD") + " " + endTime,
                  "YYYY-MM-DD h:mmA",
                  orgTimezone,
                )
                .format("YYYY-MM-DDTHH:mm:ss");
            } else {
              // Fallback if times are not provided (shouldn't happen due to validation)
              payload.start_time = moment
                .tz(
                  startDateInTz.format("YYYY-MM-DD") + " 00:00",
                  "YYYY-MM-DD HH:mm",
                  orgTimezone,
                )
                .format("YYYY-MM-DDTHH:mm:ss");
              payload.end_time = moment
                .tz(
                  endTimeDate.format("YYYY-MM-DD") + " 23:59",
                  "YYYY-MM-DD HH:mm",
                  orgTimezone,
                )
                .format("YYYY-MM-DDTHH:mm:ss");
            }
          }

          payload.recurring = isRecurringScheduleOpen;

          // Set required_end_date:
          // - If NOT recurring: same day as start date
          // - If recurring (daily/weekly/monthly): user must provide end date
          const formatEndOfDay = dateMoment =>
            dateMoment
              .clone()
              .hour(23)
              .minute(59)
              .second(0)
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss");

          if (!isRecurringScheduleOpen) {
            // Always set required_end_date to 23:59 of the start date
            payload.required_end_date = formatEndOfDay(startDateInTz);
          } else {
            payload.interval = parseInt(interval, 10) || 1;
            payload.schedule_type = selectedRecurringSchedule;
            const endDateInTz = moment.tz(endDate, orgTimezone);
            // Always set required_end_date to 23:59 of the selected end date
            payload.required_end_date = formatEndOfDay(endDateInTz);
          }
          if (
            isRecurringScheduleOpen &&
            selectedRecurringSchedule === "weekly"
          ) {
            // Convert selectedRecurringScheduleDay (e.g., "Mon" or "Monday") to day index (0-6)
            if (selectedRecurringScheduleDays.length > 0) {
              const dayIndices = selectedRecurringScheduleDays
                .map(day => {
                  let dayIndex = SHORT_WEEK_DAYS.indexOf(day);
                  if (dayIndex === -1) {
                    dayIndex = FULL_WEEK_DAYS.indexOf(day);
                  }
                  return dayIndex;
                })
                .filter(index => index !== -1);
              if (dayIndices.length > 0) {
                payload.days_of_week = dayIndices;
              }
            }
          } else if (
            isRecurringScheduleOpen &&
            selectedRecurringSchedule === "monthly"
          ) {
            if (monthlyScheduleMode === "dates") {
              let tempMonthDatesArray = [];
              for (let i = 1; i <= 31; i++) {
                if (activeMonthDates[i]) {
                  tempMonthDatesArray.push(i);
                }
              }
              payload.days_of_month = tempMonthDatesArray;
              if (activeMonthDates["Last Day"]) {
                payload.is_last_day_month = true;
              }
              payload.is_weekdays_of_month = false;
            } else if (monthlyScheduleMode === "days") {
              let tempMonthDaysArray = [];
              for (let i = 0; i <= 27; i++) {
                if (activeMonthDays[i]) {
                  tempMonthDaysArray.push(i);
                }
              }
              payload.weekdays_of_month = tempMonthDaysArray;
              payload.is_weekdays_of_month = true;
            }
          }
        }
        createJobRequest(payload);
        setIsSubmitted(true);
      }
    }
  };

  const checkPlan = () => {
    if (
      isRecurringScheduleOpen &&
      selectedOrganization &&
      selectedOrganization.plan &&
      selectedOrganization.plan.name === "Free"
    ) {
      setPricingPopupText(recurringJobsTextLabel);
      setPricingPopupTitle(recurringJobsTitleLabel);
      pricingPopupToggleLocal();
      return false;
    } else {
      return true;
    }
  };

  const checkError = () => {
    let saveErrors = {};
    let position = "";
    let formIsValid = true;
    if (!jobName.trim()) {
      formIsValid = false;
      saveErrors["jobName"] = itemNameRequiredError;
      position = "jobName";
    } else if (checkUrl(jobName)) {
      formIsValid = false;
      saveErrors["jobName"] = itemNameUrlError;
      position = "jobName";
    } else if (checkHtml(jobName)) {
      formIsValid = false;
      saveErrors["jobName"] = itemNameInvalidError;
      position = "jobName";
    } else if (jobName.length > 255) {
      formIsValid = false;
      saveErrors["jobName"] = "Please enter title within 255 characters";
      window.scrollTo(0, 0, "smooth");
      position = "jobName";
    }
    if (orgType === "service") {
      if (!selectedClient || !selectedClient.value) {
        formIsValid = false;
        saveErrors["selectedClient"] = "Customer is required";
      }
    }
    if (!selectedWorkOrder || !selectedWorkOrder.value) {
      formIsValid = false;
      saveErrors["selectedWorkOrder"] = workOrderRequiredError;
    }
    // Location is optional - remove this validation
    // if (!selectedLocation || !selectedLocation.value) {
    //   formIsValid = false;
    //   saveErrors["selectedLocation"] = "Location is required";
    // }
    // Assignees are only required when "now" is selected, not for "later"
    if (selectedScheduleForType === "now" && selectedAssignees.length === 0) {
      formIsValid = false;
      saveErrors["selectedAssignees"] = "Assignee is required";
    }
    if (checkUrl(taskDescription)) {
      formIsValid = false;
      saveErrors["taskDescription"] = itemDescriptionUrlError;
      position = "taskDescription";
    } else if (checkHtml(taskDescription)) {
      formIsValid = false;
      saveErrors["taskDescription"] = itemDescriptionInvalidError;
      position = "taskDescription";
    } else if (taskDescription.length > 512) {
      formIsValid = false;
      saveErrors["taskDescription"] =
        "Please enter description within 512 characters";
      position = "taskDescription";
    }
    if (selectedScheduleForType === "now") {
      if (!startDate) {
        formIsValid = false;
      }
      if (!isAnyTimeSet && (!startTime || !endTime)) {
        formIsValid = false;
        saveErrors["timeDifference"] = "Start time and end time are required";
        position = "time";
      }
      if (
        !isAnyTimeSet &&
        startTime &&
        endTime &&
        moment(startDate.format("YYYY-MM-DD") + " " + endTime).diff(
          moment(startDate.format("YYYY-MM-DD") + " " + startTime),
        ) < 1
      ) {
        formIsValid = false;
        saveErrors["timeDifference"] = "End time must be after start time";
        position = "time";
      } else if (
        !isAnyTimeSet &&
        startTime &&
        endTime &&
        moment(startDate.format("YYYY-MM-DD") + " " + endTime).diff(
          moment(startDate.format("YYYY-MM-DD") + " " + startTime),
        ) < 1800000
      ) {
        formIsValid = false;
        saveErrors["timeDifference"] =
          "Minmium 30 minutes time difference required";
        position = "time";
      }
      if (
        !isAnyTimeSet &&
        startTime &&
        moment(startDate.format("YYYY-MM-DD") + " " + startTime).diff(
          moment(),
        ) < 1
      ) {
        formIsValid = false;
        saveErrors["timeDifference"] = "Past time can't be set";
        position = "time";
      }
      // Recurring schedule validations
      if (isRecurringScheduleOpen) {
        if (!endDate) {
          formIsValid = false;
          saveErrors["endDate"] = "End date is required for recurring schedule";
        }
        if (!selectedRecurringSchedule) {
          formIsValid = false;
          saveErrors["selectedRecurringSchedule"] =
            "Recurring schedule type must be selected";
        }
        if (!interval || parseInt(interval, 10) < 1) {
          formIsValid = false;
          saveErrors["interval"] = "Repeat value must be at least 1";
        } else if (
          selectedRecurringSchedule === "daily" &&
          parseInt(interval, 10) > 150
        ) {
          formIsValid = false;
          saveErrors["interval"] =
            "Interval maximum limit is 150 for daily schedule";
        } else if (
          selectedRecurringSchedule === "weekly" &&
          parseInt(interval, 10) > 25
        ) {
          formIsValid = false;
          saveErrors["interval"] =
            "Interval maximum limit is 25 for weekly schedule";
        } else if (
          selectedRecurringSchedule === "monthly" &&
          parseInt(interval, 10) > 12
        ) {
          formIsValid = false;
          saveErrors["interval"] =
            "Interval maximum limit is 12 for monthly schedule";
        }
        if (selectedRecurringSchedule === "weekly") {
          if (!selectedRecurringScheduleDays.length) {
            formIsValid = false;
            saveErrors["selectedRecurringScheduleDay"] =
              "At least one weekday must be selected for weekly schedule";
          }
        }
        if (selectedRecurringSchedule === "monthly") {
          if (monthlyScheduleMode === "dates") {
            let hasSelectedDates = false;
            Object.keys(activeMonthDates).forEach(key => {
              if (activeMonthDates[key] === true) {
                hasSelectedDates = true;
              }
            });
            if (!hasSelectedDates) {
              formIsValid = false;
              saveErrors["activeMonthDates"] =
                "At least one date must be selected for monthly schedule";
            }
          } else if (monthlyScheduleMode === "days") {
            let hasSelectedDays = false;
            Object.keys(activeMonthDays).forEach(key => {
              if (activeMonthDays[key] === true) {
                hasSelectedDays = true;
              }
            });
            if (!hasSelectedDays) {
              formIsValid = false;
              saveErrors["activeMonthDays"] =
                "At least one weekday must be selected for monthly schedule";
            }
          }
        }
      }
    }
    setSaveErrors(saveErrors);
    if (position) {
      handleScroll(position);
    }
    return formIsValid;
  };

  const handleScroll = position => {
    if (position === "jobName") {
      scrollName.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else if (position === "taskDescription") {
      scrollDescription.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else if (position === "time") {
      scrollTime.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const ThemeColorComp = ({ color }) => (
    <ThemeBox color={color} onClick={() => handleThemeColor(color)}>
      {themeColor === color && <img src={tick} alt="" width="18px" />}
    </ThemeBox>
  );
  const handleAnytimeToggle = () => {
    setIsAnyTimeSet(prev => !prev);
    if (!isAnyTimeSet) {
      setSaveErrors(prevErrors => {
        const errors = { ...prevErrors };
        delete errors["timeDifference"];
        return errors;
      });
    }
  };

  const toggleRecurringWeekDay = day => {
    setSelectedRecurringScheduleDays(prev => {
      if (prev.includes(day)) {
        return prev.filter(item => item !== day);
      }
      return [...prev, day];
    });
    setSaveErrors(prevErrors => {
      const errors = { ...prevErrors };
      delete errors["selectedRecurringScheduleDay"];
      return errors;
    });
  };

  const handleIntervalChange = e => {
    const { value } = e.target;
    if (value === "") {
      setInterval("");
      return;
    }
    const parsed = parseInt(value, 10);
    if (!isNaN(parsed) && parsed > 0) {
      setInterval(parsed);
    }
  };

  const handleMonthlyIntervalChange = option => {
    setInterval(option ? option.value : 1);
    let errors = { ...saveErrors };
    delete errors["interval"];
    setSaveErrors(errors);
  };

  const monthlyIntervalOptions = [
    { label: "Every month", value: 1 },
    { label: "Every 2 months", value: 2 },
    { label: "Every 3 months", value: 3 },
    { label: "Every 6 months", value: 6 },
    { label: "Every 12 months", value: 12 },
  ];

  const renderRepeatIntervalInput = unit => {
    // Determine max value based on schedule type
    let maxValue;
    if (selectedRecurringSchedule === "daily") {
      maxValue = 150;
    } else if (selectedRecurringSchedule === "weekly") {
      maxValue = 25;
    } else {
      maxValue = undefined; // No max for other types
    }

    return (
      <CommonFlex
        alignItems="start"
        direction="column"
        gap="5px"
        margin="20px 0 0"
      >
        <CommonFlex style={{ width: "100%" }}>
          <CommonText>Repeat every</CommonText>
          <InputField
            type="number"
            min="1"
            max={maxValue}
            value={interval}
            onChange={handleIntervalChange}
            style={{
              maxWidth: "90px",
              textAlign: "center",
              border:
                saveErrors && saveErrors["interval"]
                  ? "1px solid #fe5969"
                  : undefined,
              backgroundColor:
                saveErrors && saveErrors["interval"]
                  ? "rgba(252, 87, 104, 0.05)"
                  : undefined,
            }}
          />
          <CommonText>{unit}</CommonText>
        </CommonFlex>
        {saveErrors && saveErrors["interval"] && (
          <FormAlert style={{ marginBottom: 0 }}>
            {saveErrors["interval"]}
          </FormAlert>
        )}
      </CommonFlex>
    );
  };

  const buildMomentWithTime = (timeValue, dateValue) => {
    if (!timeValue || !dateValue) {
      return null;
    }

    // Parse time value first
    const timeFormats = ["HH:mm:ss", "HH:mm", "h:mmA", "h:mm A"];
    const timeMoment = moment(timeValue, timeFormats, false); // Not strict

    if (timeMoment.isValid()) {
      // Combine with date
      const dateOnly = moment(dateValue).startOf("day");
      return dateOnly
        .hour(timeMoment.hour())
        .minute(timeMoment.minute())
        .second(timeMoment.second() || 0);
    }

    // Fallback: try parsing the full date-time string
    const dateString = `${dateValue.format("YYYY-MM-DD")} ${timeValue}`;
    const parsed = moment(
      dateString,
      [
        "YYYY-MM-DD HH:mm:ss",
        "YYYY-MM-DD HH:mm",
        "YYYY-MM-DD h:mmA",
        "YYYY-MM-DD h:mm A",
      ],
      false,
    ); // Not strict

    return parsed.isValid() ? parsed : null;
  };

  const getJobDurationText = () => {
    if (!startDate || !startTime || !endTime || isAnyTimeSet) {
      return "-";
    }
    const startMomentFull = buildMomentWithTime(startTime, startDate);
    const endMomentFull = buildMomentWithTime(endTime, startDate);
    if (!startMomentFull || !endMomentFull) {
      return "-";
    }
    const diffInSeconds = endMomentFull.diff(startMomentFull, "seconds");
    if (diffInSeconds <= 0) {
      return "-";
    }
    return formatDurationToHoursMinutes(diffInSeconds);
  };

  const googleMapsKey =
    process.env.REACT_APP_GOOGLE_MAPS_KEY ||
    process.env.REACT_APP_GOOGLE_MAPS_JAVASCRIPT_API_KEY;

  const fallbackMapUrl = useMemo(() => {
    const buildStaticMap = (lat, lng, zoom = 8) => {
      if (!googleMapsKey || lat === undefined || lng === undefined) return null;
      const baseUrl = `https://maps.googleapis.com/maps/api/staticmap?key=${ process.env.REACT_APP_GOOGLE_MAPS_JAVASCRIPT_API_KEY}&size=640x280&zoom=${zoom}&scale=1&language=en&center=${lat},${lng}`;
      const markers = `&markers=color:red%7C${lat},${lng}`;
      return `${baseUrl}${markers}`;
    };

    // Prefer explicit organization coordinates if provided
    const orgLat = selectedOrganization?.latitude || selectedOrganization?.lat;
    const orgLng = selectedOrganization?.longitude || selectedOrganization?.lng;
    if (orgLat && orgLng) {
      return buildStaticMap(orgLat, orgLng, 8);
    }

    // Try timezone -> coordinates mapping
    const tz = selectedOrganization?.timezone || moment.tz.guess();
    const coords = timezoneToCoords(tz);
    if (coords) {
      return buildStaticMap(coords.lat, coords.lng, coords.zoom);
    }

    // Default: world view centered at 0,0
    return buildStaticMap(0, 0, 2);
  }, [googleMapsKey, selectedOrganization]);

  const handleProjectModalToggle = () => {
    setIsProjectModalOpen(!isProjectModalOpen);
  };

  const handleProjectCreated = createdProject => {
    // Refresh the work order list to include the newly created project
    if (selectedOrganization && selectedOrganization.id) {
      getWorkOrderShortList({ organization_id: selectedOrganization.id });
    }
    // Select the newly created project after a short delay to allow the list to update
    setTimeout(() => {
      if (createdProject && createdProject.id) {
        const projectOption = {
          value: createdProject.id,
          label: createdProject.name,
          client_id: createdProject.client_id || null,
          client_name: createdProject.client_name || null,
        };
        onWorkOrderChange(projectOption);
      }
    }, 500);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{ maxWidth: `800px` }}
      backdrop="static"
    >
      <ModalBody
        style={{
          padding: `25px`,
          minHeight: `800px`,
          display: `flex`,
          flexDirection: `column`,
          position: `relative`,
        }}
      >
        {orgType === "operation" ? (
          <AddOrgLocationModal
            isOpen={popupOpen}
            toggle={popupToggle}
            organization_id={selectedOrganization?.id}
            addOrgLocation={createOrgLocation}
            addOrgLocationLoading={addOrgLocationLoading}
            createdOrgLocationInfo={createdOrgLocationInfo}
            selectedOrganization={selectedOrganization}
          />
        ) : (
          <AddLocationModal
            isOpen={popupOpen}
            toggle={popupToggle}
            addClientLocation={addClientLocation}
            addOrUpdateclientLocalMapLoading={addOrUpdateclientLocalMapLoading}
            createdClientLocationInfo={createdClientLocationInfo}
            organization_id={selectedOrganization.id}
            client_id={clientId ? clientId : null}
            action="add"
            selectedOrganization={selectedOrganization}
          />
        )}
        <CreateProjectModal
          isOpen={isProjectModalOpen}
          toggle={handleProjectModalToggle}
          selectedOrganization={selectedOrganization}
          onProjectCreated={handleProjectCreated}
        />
        {/* Only render conflict panel when it should be open - prevents flash */}
        {isConflictPanelOpen && (
          <JobConflictSidePanelContainer
            isOpen={isConflictPanelOpen}
            closePanel={() => setIsConflictPanelOpen(false)}
            assignee={conflictAssignee}
            startDate={startDate}
            startTime={startTime}
            endTime={endTime}
            endDate={endDate}
            isRecurring={isRecurringScheduleOpen}
          />
        )}
        {selectedOrganization &&
          selectedOrganization.id &&
          orgType === "service" && (
            <ClientModal
              isOpen={isClientModalOpen}
              toggle={toggleClientModal}
              selectedOrganization={selectedOrganization}
              createClient={createClient}
              isClientLoading={isClientLoading}
              createdClientId={createdClientId}
              createdClientInfo={createdClientInfo}
              setSelectedClient={handleClientChange}
              addClientLocation={addClientLocation}
              getClientLocation={getClientLocation}
              addOrUpdateclientLocalMapLoading={addOrUpdateclientLocalMapLoading}
              createdClientLocationInfo={createdClientLocationInfo}
              clientLocationList={clientLocationList}
              clientId={clientId}
              orgType={orgType}
            />
          )}
        <AddSubTaskModal
          isOpen={isSubTaskModalOpen}
          toggle={() => setIsSubTaskModalOpen(!isSubTaskModalOpen)}
          setSubTaskList={setSubTaskList}
          subTaskList={subTaskList}
        />
        <EditSubTaskModal
          isOpen={isEditSubTaskModalOpen}
          toggle={closeEditSubTaskModal}
          setSubTaskList={setSubTaskList}
          subTaskList={subTaskList}
          subTaskId={selectedSubTaskId}
        />
        {pricingPopupToggle ? (
          <PricingPlan
            isOpen={pricingPopup}
            toggle={pricingPopupToggle}
            popupText={pricingPopupText}
            popupTitle={pricingPopupTitle}
            onlyElite
          />
        ) : (
          <PricingPlan
            isOpen={pricingPopup}
            toggle={pricingPopupToggleLocal}
            popupText={pricingPopupText}
            popupTitle={pricingPopupTitle}
            onlyElite
          />
        )}
        <ModalCrossIcon src={crossIcon} alt="close" onClick={handleCancel} />
        <Container padding="10px" gap="20px">
          <CommonText name title fontSize="16px">
            {addItemDetailsLabel}
          </CommonText>
          <CommonGrid disableResponsive={true} columns="1fr">
            <JobInputSection
              jobName={jobName}
              jobNumber={jobNumber}
              selectedWorkOrder={selectedWorkOrder}
              workOrderOptions={orgType === "service" && clientId ? filteredWorkOrderOptions : workOrderOptions}
              selectedClient={selectedClient}
              clientOptions={clientOptions}
              taskDescription={taskDescription}
              onTaskNameChange={onTaskNameChange}
              onJobNumberChange={onJobNumberChange}
              onWorkOrderChange={onWorkOrderChange}
              onTaskDescriptionChange={onTaskDescriptionChange}
              handleProjectModalToggle={handleProjectModalToggle}
              onClientChange={handleClientChange}
              onAddCustomer={toggleClientModal}
              scrollName={scrollName}
              scrollDescription={scrollDescription}
              jobInputRef={jobInputRef}
              orgType={orgType}
              saveErrors={saveErrors}
              mode="create"
            />
            <CommonFlex
              gap="6px"
              disableResponsive
              alignItems="none"
              direction="column"
              style={{ paddingRight: "16px" }}
            >
              <CommonGrid margin="0 10px 0px 0">
                <InputLabel>{t("location")} </InputLabel>
                {(orgType === "operation" ||
                  (orgType === "service" && clientId)) && (
                  <CommonText
                    fontSize="13px"
                    color="#2266EF"
                    margin="0 0 0 0"
                    fontWeight="550"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      popupToggle();
                    }}
                  >
                    <ButtonIcon src={Plus} alt="" /> Add Location
                  </CommonText>
                )}
              </CommonGrid>
              <CommonCardContainer padding="24px">
                <SingleLocationMap location={selectedLocation} />
                <CommonGrid margin="10px 0 0 0" columns="1fr 200px">
                  <CommonText>{selectedLocation?.address}</CommonText>
                  <Select
                    isSearchable
                    value={selectedLocation}
                    options={jobLocationOptions}
                    placeholder={t("select_location")}
                    onChange={option => onLocationChange(option)}
                    styles={CreateProjectDropdown({
                      error: saveErrors && saveErrors["selectedLocation"],
                    })}
                    filterOption={filterOption}
                  />
                </CommonGrid>
                {saveErrors && saveErrors["selectedLocation"] && (
                  <FormAlert>{saveErrors["selectedLocation"]}</FormAlert>
                )}
              </CommonCardContainer>
            </CommonFlex>
          </CommonGrid>
          <HorizontalLineDivider margin="5px 0" />
          <CommonGrid disableResponsive columns="1fr">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <CommonGrid gap="20px" columns="1fr">
                <CommonFlex direction="column" alignItems="start" gap="10px">
                  <InputLabel>Schedule For</InputLabel>
                  <CommonGrid
                    justifyContent="flex-start"
                    disableResponsive
                    gap="4px"
                    alignItem="center"
                  >
                    <RoundTab
                      onClick={() => setSelectedScheduleForType("now")}
                      selected={selectedScheduleForType === "now"}
                      text="Now"
                    />
                    <RoundTab
                      onClick={() => setSelectedScheduleForType("later")}
                      selected={selectedScheduleForType === "later"}
                      text="Later"
                    />
                  </CommonGrid>
                </CommonFlex>
                {selectedScheduleForType === "now" && (
                  <JobStartTimeSection
                    setStartTime={setStartTime}
                    setEndTime={setEndTime}
                    startDate={startDate}
                    onDateChange={onDateChange}
                    isAnyTimeSet={isAnyTimeSet}
                    handleAnytimeToggle={handleAnytimeToggle}
                    startTime={startTime}
                    endTime={endTime}
                    saveErrors={saveErrors}
                    getJobDurationText={getJobDurationText}
                    scrollTime={scrollTime}
                    handleStartTime={handleStartTime}
                    handleEndTime={handleEndTime}
                    orgType={orgType}
                  />
                )}
              </CommonGrid>
            </div>
          </CommonGrid>
          {!isRecurringScheduleOpen && selectedScheduleForType !== "later" && (
            <CommonGrid>
              <BorderButtonWithIcon
                onClick={() => {
                  setIsRecurringScheduleOpen(!isRecurringScheduleOpen);
                  // Set end date to start date when opening recurring schedule
                  if (!endDate) {
                    setEndDate(startDate);
                  }
                }}
              >
                <ButtonIcon src={Plus} alt="" />
                Recurring Schedule
              </BorderButtonWithIcon>
            </CommonGrid>
          )}

          <RecurringScheduleSection
            isRecurringScheduleOpen={isRecurringScheduleOpen}
            setIsRecurringScheduleOpen={setIsRecurringScheduleOpen}
            selectedRecurringSchedule={selectedRecurringSchedule}
            setSelectedRecurringSchedule={onRecurringScheduleTypeChange}
            selectedRecurringScheduleDays={selectedRecurringScheduleDays}
            toggleRecurringWeekDay={toggleRecurringWeekDay}
            monthlyScheduleMode={monthlyScheduleMode}
            setMonthlyScheduleMode={setMonthlyScheduleMode}
            interval={interval}
            handleIntervalChange={handleIntervalChange}
            handleMonthlyIntervalChange={handleMonthlyIntervalChange}
            activeMonthDates={activeMonthDates}
            onMonthDateSelect={onMonthDateSelect}
            activeMonthDays={activeMonthDays}
            onMonthDaySelect={onMonthDaySelect}
            saveErrors={saveErrors}
            endDate={endDate}
            onEndDateSelect={onEndDateSelect}
            startDate={startDate}
            monthlyDatesSummary={monthlyDatesSummary}
            monthlyDaysSummary={monthlyDaysSummary}
          />
          <HorizontalLineDivider margin="5px 0" />
              <AssigneeNew
                isLoading={jobAssigneeMemberListIsLoading}
                assigneesList={selectedAssignees}
                membersList={jobAssigneeMemberList}
                handleAssign={handleAssignMember}
                handleRemove={handleRemoveMember}
                onConflictClick={person => {
                  setConflictAssignee(person);
                  setIsConflictPanelOpen(true);
                }}
                isRequired={selectedScheduleForType === "now"}
                selectedOrganization={selectedOrganization}
              />
            

         

          {orgType === "operation" && (
            <SubtaskSection
              subTaskList={subTaskList}
              setSubTaskList={setSubTaskList}
              setIsSubTaskModalOpen={setIsSubTaskModalOpen}
              openEditSubTaskModal={openEditSubTaskModal}
            />
          )}
          {orgType !== "operation" && (
            <LineItemSection
              setLineItems={setLineItems}
              currency={selectedOrganization?.configuration?.currency || "USD"}
            />
          )}

          {orgType !== "operation" && (
            <CommonCardContainer style={{ marginTop: "10px" }}>
              <DocumentUploadSection
                documents={documents}
                setDocuments={setDocuments}
              />
            </CommonCardContainer>
          )}

          <InputWithLabelSection>
            <CommonFlex gap="12px">
              <InfoTooltip
                toolTipText="Select a theme color for the job to help visually distinguish it from others.."
                mainText={t("choose_theme")}
              />
            </CommonFlex>

            <ThemesContainer>
              <ThemeColorComp color="#D4F4EE" />
              <ThemeColorComp color="#D2E4FE" />
              <ThemeColorComp color="#D9D7FC" />
              <ThemeColorComp color="#FDF3E4" />
            </ThemesContainer>
          </InputWithLabelSection>
          
          <CommonFlex
            justifyContent="flex-end"
            gap="10px"
            style={{ marginTop: `auto`, paddingTop: `20px` }}
          >
            <WhiteButton width="140px" type="cancel" onClick={handleCancel}>
              {t("cancel")}
            </WhiteButton>
            <PrimaryButton
              disabled={handleDisable()}
              onClick={() => handleSave()}
              padding="0 25px"
              width="140px"
            >
              {createOrUpdateJobIsLoading ? (
                <ButtonTextLoader loadingText={t("creating")} fontSize="13px" />
              ) : (
                createItemLabel
              )}
            </PrimaryButton>
          </CommonFlex>
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default CreateJobPopupNew;
